import { animate } from 'animejs';

export const animatePins = (isEnabled: boolean) => {
  animate('.animate-pin', {
    'box-shadow': '0 0 0px 5px rgba(4, 104, 255, 0.42)',
    alternate: true,
    loop: true,
    onUpdate: e => {
      if (!isEnabled) {
        e.cancel();
      }
    },
  });
};

export const animateBigPin = (isEnabled: boolean) => {
  animate('.animated-big-pin', {
    'box-shadow': '0 0 0px 10px rgba(4, 104, 255, 0.42)',
    alternate: true,
    loop: true,
    onUpdate: e => {
      if (!isEnabled) {
        e.cancel();
      }
    },
  });
};
